export const GetToken = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_BASE_URL}/tableau/get-token`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' }
    })
    const result = await data.json()
    if (data.status === 200) {
        return result
    } else {
        throw new Error(result.detail)
    }
}

export const GetLocationNumberBySap = async (category: string, sap_id: number)=> {
    if(!category){
        category = 'LCBO'
    }
    const data = await fetch(`${process.env.REACT_APP_API_BASE_URL}/tableau/get-location/${category}/${sap_id}`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' }
    })
    const result = await data.json()
    if (data.status === 200) {
        return result
    } else {
        throw new Error(result.detail)
    }
}